<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { del } from '@/js/api/sourcer';
import Config from '@/js/config';
import './assets/styles/custom.scss';

export default {
  name: 'App',

  created() {
    // checking Cookies
    const siteVersion = Cookies.get('site_version');
    const session = localStorage.getItem('session');
    if (session && !siteVersion) {
      // logout user
      del(`${Config.env.API_URL}sessions`)
        .then(() => {
          this.$store.dispatch('auth/logout');
          window.location.reload();
        })
        .catch(() => {
          this.$store.dispatch('auth/logout');
          window.location.reload();
        });
    }
  },
};
</script>

<style lang="scss">
@import './assets/styles/variables.scss';
@import 'assets/css/main.css';
@import 'assets/css/styles.css';

#app {
  font-family: 'IBM Plex Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #444;
  padding-bottom: 0px;
}
.navbar {
  background-color: $primary;
}
.navbar h2 {
  color: white;
  font-weight: bold;
  text-align: center;
  width: 80%;
  margin: 0 auto;
}
.btn-primary:hover,
.btn-primary:active {
  background: #2d9b7f;
}
a:hover {
  color: #444;
}
</style>
